import { useCallback } from "react";
import { useTermSheetContext } from "hooks";

/**
 * useTermSheetHandlers
 * Custom hook that provides handlers for tracking cell-level changes
 * Handles local state management for pending edits before they're saved
 */
export default function useTermSheetHandlers() {
  const { setChanges, onUpdate } = useTermSheetContext();

  /**
   * Handle cell value change
   */
  const handleChange = useCallback(
    (assignmentId, columnKey, value) => {
      setChanges((prev) => ({
        ...prev,
        [assignmentId]: {
          ...prev[assignmentId],
          [columnKey]: value,
        },
      }));

      // Notify parent component if callback provided
      if (typeof onUpdate === "function") {
        onUpdate(assignmentId, columnKey, value);
      }
    },
    [setChanges, onUpdate]
  );

  /**
   * Handle reverting a cell change
   */
  const handleRevert = useCallback(
    (assignmentId, columnKey) => {
      setChanges((prev) => {
        // eslint-disable-next-line no-unused-vars
        const { [columnKey]: _, ...rest } = prev[assignmentId] || {};
        return {
          ...prev,
          [assignmentId]: rest,
        };
      });
    },
    [setChanges]
  );

  return {
    handleChange,
    handleRevert,
  };
}
